import React from 'react';
import ClientOnboard from './ClientOnboard';

export default function ClientParent() {
  return <ClientOnboard />;
}
